import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import configData from "./config.json";
import Cookies from 'js-cookie';

function ResetPassword() {
  const [loginStart, setLoginStart] = useState(false);
  // eslint-disable-next-line
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  const [apiErrorMessage, setApiErrorMessage] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [matchPasswordError, setMatchPasswordError] = useState('');
  const [resetEmail, setResetEmail] = useState('');
  // eslint-disable-next-line
  const navigate = useNavigate();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setResetEmail(urlParams.get('e'));
  }, []);

  const doUserLogIn = async function () {
    setPasswordError('');
    setApiErrorMessage('');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('e');
    const token = urlParams.get('t');
    
    if (password !== '') {
      if (confirmPassword !== '') {
        if(password === confirmPassword) {
          setLoginStart(true);
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, token: token, password: password })
          };
          try {
            fetch(configData.SERVER_URL+"/resetPassword", requestOptions)
              .then(response => {
                return response.json()
              })
              .then(results => {
                if (results.success === true) {
                  sessionStorage.setItem("successMessage", results.message);
                  setApiSuccessMessage(results.message);
                  navigate("/");
                } else {
                  setApiErrorMessage(results.message);
                }
                setLoginStart(false);
              }).catch(error=>{
                alert("There is some error in processing your request. Please try again in some time.");
              })
            return true;
          } catch (error) {
            setApiErrorMessage('Something went wrong. Please Try Again.');
            return false;
          }
        }else {
          setMatchPasswordError('Please make sure your passwords match.');
        }
      }else {
        setConfirmPasswordError('This field is required.');
      }
    } else {
      setPasswordError('This field is required.');
    }
  };

  const keyDownHandler = event => {
    setPasswordError('');
    setConfirmPasswordError('');
    setMatchPasswordError('');
    if (event.key === 'Enter') {
      event.preventDefault();
      doUserLogIn();
    }
  }

  if (!Cookies.get('status')) {
    return (

      <div className="d-flex bg_main justify-content-between">
        <div className="login_content">
          <div className="login_text">
            <h2 className="login_heading">Harnessing Data to Drive Smarter Advertising Decisions.</h2>
            <p>Elevate Your Website's Ad Placement Strategy with<br /> Advanced Analytics.</p>
          </div>
          <div className="login_img">
            <img src="assets/media/images/login_img.svg" alt="login" />
          </div>
        </div>

        <div className="login_form d-flex align-items-center justify-content-center">
          <div className="login_form_inner">
            
            {/* <div className="success_message" style={{ opacity: (Cookies.get('registration_msg')) ? 1 : 0 }}>
              <div className="d-flex align-items-center">
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M13.9999 2.33325L17.0641 4.56859L20.8575 4.56159L22.0225 8.17125L25.0955 10.3949L23.9165 13.9999L25.0955 17.6049L22.0225 19.8286L20.8575 23.4383L17.0641 23.4313L13.9999 25.6666L10.9356 23.4313L7.14221 23.4383L5.9773 19.8286L2.9043 17.6049L4.08321 13.9999L2.9043 10.3949L5.9773 8.17125L7.14221 4.56159L10.9356 4.56859L13.9999 2.33325Z" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.91675 13.9999L12.8334 16.9166L18.6667 11.0833" stroke="#008500" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="text">
                  <h5 className="succcess_heading">Thank You</h5>
                  <p>Please check your email for Password reset link.</p>
                </div>
              </div>
            </div> */}

            {apiErrorMessage && <div className="error_message">
              <div className="d-flex align-items-center">
                <div className="icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.61636 23.8429H22.3965C24.2422 23.8429 25.4007 21.8479 24.4837 20.2449L16.1 5.58571C15.1772 3.97221 12.8509 3.97104 11.9269 5.58454L3.52919 20.2437C2.61219 21.8467 3.76953 23.8429 5.61636 23.8429Z" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.003 15.6506V12.0339" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.9942 19.2498H14.0059" stroke="#ED0017" strokeWidth="2.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </div>
                <div className="text">
                  <h5 className="succcess_heading">{apiErrorMessage}</h5>
                </div>
              </div>
            </div>}

            <div className="form_group">
              <h1 className="heading mb_10px">Reset Password</h1>
              <p className="text_dark mb_49px">
                Enter a new password for &nbsp;
                <span className="text_primary">
                  {resetEmail}
                </span>
                  {/* <Link to='/' className="btn-icon btn back_btn"> */}
                    <div className="btn-icon btn back_btn">
                      {/* <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.01929 11.9251H12.25" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.455 2.21363C7.90746 1.67288 8.72083 1.59358 9.2728 2.03684C9.30332 2.06089 10.2839 2.82263 10.2839 2.82263C10.8902 3.1892 11.0787 3.96848 10.7038 4.56318C10.6839 4.59502 5.1403 11.5293 5.1403 11.5293C4.95587 11.7594 4.6759 11.8952 4.3767 11.8984L2.25372 11.9251L1.77539 9.90052C1.70839 9.61584 1.77539 9.31687 1.95983 9.08679L7.455 2.21363Z" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6.42871 3.50049L9.60919 5.94298" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> */}
                    </div>
                  {/* </Link> */}
              </p>
            </div>
            
            <div className="form_group mb_5px">
              <label htmlFor="exampleFormControlInput2" className="form-label">Password</label>
              <div className="view_pass">
                <div className={(password) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                  <span className="input-group-text" id="addon-wrapping">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6868 7.87321V6.08404C13.6868 3.98987 11.9884 2.29154 9.89427 2.29154C7.8001 2.28237 6.0951 3.97237 6.08594 6.06737V6.08404V7.87321" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.0695 17.7081H6.70199C4.95699 17.7081 3.54199 16.294 3.54199 14.5481V10.974C3.54199 9.22813 4.95699 7.81396 6.70199 7.81396H13.0695C14.8145 7.81396 16.2295 9.22813 16.2295 10.974V14.5481C16.2295 16.294 14.8145 17.7081 13.0695 17.7081Z" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.88639 11.8357V13.6865" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <input type="password" className="form_control password" placeholder="Enter new password" aria-label="UserPassword" aria-describedby="addon-wrapping" value={password} onChange={(event) => setPassword(event.target.value)} onKeyDown={keyDownHandler} />
                </div>
              </div>
              <span className="error mb-2">{passwordError}</span>
            </div>

            <div className="form_group mb_5px">
              <label htmlFor="exampleFormControlInput2" className="form-label">Confirm Password</label>
              <div className="view_pass">
                <div className={(confirmPassword) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                  <span className="input-group-text" id="addon-wrapping">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6868 7.87321V6.08404C13.6868 3.98987 11.9884 2.29154 9.89427 2.29154C7.8001 2.28237 6.0951 3.97237 6.08594 6.06737V6.08404V7.87321" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.0695 17.7081H6.70199C4.95699 17.7081 3.54199 16.294 3.54199 14.5481V10.974C3.54199 9.22813 4.95699 7.81396 6.70199 7.81396H13.0695C14.8145 7.81396 16.2295 9.22813 16.2295 10.974V14.5481C16.2295 16.294 14.8145 17.7081 13.0695 17.7081Z" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.88639 11.8357V13.6865" stroke="#CFD3D4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <input type="password" className="form_control password" placeholder="Confirm new password" aria-label="UserPassword" aria-describedby="addon-wrapping" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} onKeyDown={keyDownHandler} />
                </div>
              </div>
              <span className="error mb-2">{confirmPasswordError}{matchPasswordError}</span>
            </div>

            
            
            
            
            <div className="form_group mb-0 mt_26px">
              <button type="button" className={(loginStart) ? 'btn_primary loading_btn' : 'btn_primary'} onClick={() => doUserLogIn()}>
                {
                  (loginStart)
                    ?
                    <>
                      <span className="loader_text hide">RESETTING... <i className="fa fa-spinner fa-spin ms-1"></i></span>
                    </>
                    :
                    <>
                      <span className="btn_text">RESET PASSWORD</span>
                    </>
                }
              </button>
            </div>

            {/* <span className="error">{apiErrorMessage}</span> */}
            {/* <span className="success">{apiSuccessMessage}</span> */}
            {/* <div className="form_group mb_50px text-center">
              <Link to='/'><button className="loginModeBtn otpBtn" type="button">Back to Sign In</button></Link>
            </div> */}
          </div>
        </div>
      </div >
    );
  } else {
    window.location.href = "/dashboard";
  }
}

export default ResetPassword;